<template>
    <div class="modal fade" id="bulkEmailCustomizeModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false" style="z-index: 1600;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header font-bold bg-teal text-white">
                    <h5 class="modal-title" id="exampleModalLabel">Select Contact Type</h5>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <span class="step-counter-text ml-auto mr-2">Step {{ bulkEmailCurrentStep }} of {{ bulkEmailTotalSteps }}</span>
                    </div>
                    <div class="row">
                        <div class="col-12 select-all-options">
                            <input type="checkbox" id="selectAll" value="selectAll" @change="selectAllOptions" v-model="selectAll">
                            <label for="selectAll" class="custom-label">Select all</label>
                        </div>
                        <div class="col-12" v-for="option in options">
                            <input type="checkbox" :id="option.id" :value="option.value" @change="selectOption" v-model="selectedOptions">
                            <label :for="option.id" class="custom-label">{{ option.label }}</label>
                        </div>
                    </div>
                </div>
                <div class="modal-footer flex justify-content-between">
                    <button type="button" class="btn custom-border" @click="close">Back</button>
                    <button type="button" class="btn btn-primary" @click="save">Next</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "bulk-email-customize-modal",
    data() {
        return {
            options: [
                {id: 'ProjectContact', value: 'ProjectContact', label: 'Project Contact'},
                {id: 'CompanyContactNoBidStatus', value: 'CompanyContactNoBidStatus', label: 'Company Contact Status: NoBid'},
                {id: 'CompanyContactPendingStatus', value: 'CompanyContactPendingStatus', label: 'Company Contact Status: Pending'},
                {id: 'CompanyContactWonStatus', value: 'CompanyContactWonStatus', label: 'Company Contact Status: Won'},
                {id: 'CompanyContactLostStatus', value: 'CompanyContactLostStatus', label: 'Company Contact Status: Lost'},
                {id: 'CompanyContactLostGCAwardedStatus', value: 'CompanyContactLostGCAwardedStatus', label: 'Company Contact Status: Lost - GC Awarded'},
                {id: 'CompanyContactLostGCNotAwardedStatus', value: 'CompanyContactLostGCNotAwardedStatus', label: 'Company Contact Status: Lost - GC Not Awarded'}
            ],
            selectedOptions: [],
            selectAll: false,
            bulkEmailTotalSteps: 1,
            bulkEmailCurrentStep: 1
        }
    },
    mounted() {
        let self = this;
        self.selectAll = true;
        self.selectAllOptions();

        Bus.$on('next-contact-type-modal-current-step', function(currentStep, totalSteps) {
            self.bulkEmailTotalSteps = totalSteps;
            self.bulkEmailCurrentStep = currentStep;
        });
    },
    methods: {
        open() {
            $("#bulkEmailCustomizeModal").modal("show");
        },
        close() {
            this.bulkEmailCurrentStep -= 1;
            Bus.$emit('bulk-email-modal-current-step', this.bulkEmailCurrentStep);
            $("#bulkEmailCustomizeModal").modal("hide");
        },
        selectOption() {
            this.selectAll = this.options.length === this.selectedOptions.length;
        },
        selectAllOptions() {
            let self = this;
            self.selectedOptions = [];
            self.selectedOptions = self.selectAll ? self.options.map(a => a.value) : [];
        },
        save() {
            if(this.selectedOptions.length === 0) {
                this.getToast().fire({
                    type: 'error',
                    title: "Please select at least one option."
                });
                return false;
            }

            this.bulkEmailCurrentStep += 1;
            Bus.$emit('bulk-email-modal-current-step', this.bulkEmailCurrentStep);
            Bus.$emit('save-customize-modal-data', this.selectedOptions);
            Bus.$emit('close-customize-modal-data');
            $("#bulkEmailCustomizeModal").modal("hide");
        }
    }
}
</script>

<style scoped>
.custom-label {
    font-size: 15px;
}
.select-all-options {
    margin-bottom: 10px;
    border-bottom: 1px solid #3d4852;
}
.custom-border {
    border: 1px solid !important;
}
.step-counter-text {
    font-size: 15px;
    font-weight: 600;
}
</style>
